<script lang="ts">
	import christmasHeroImage from "@assets/images/homepage-hero-christmas.jpg?webp&quality=95&imagetools";
	import heroImageLg from "@assets/images/homepage-hero.jpg?webp&h=2200&imagetools";
	import heroImageXl from "@assets/images/homepage-hero.jpg?webp&h=2800&imagetools";
	import heroImage3xl from "@assets/images/homepage-hero.jpg?webp&imagetools";
	import heroImageXs from "@assets/images/homepage-hero.jpg?webp&quality=95&h=1000&imagetools";
	import heroImageSm from "@assets/images/homepage-hero.jpg?webp&quality=95&h=1600&imagetools";
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { clarityEvent } from "@utils/clarity.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import logo from "@core/assets/images/fathers-logo-alt.svg?raw";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { CategoryType } from "@core/schema/CategoryType.js";
	import { getCategoryPath } from "@core/schema/paths/getCategoryPath.js";
	import { getChristmasPath } from "@core/schema/paths/getChristmasPath.js";
	import { tw } from "@core/utils/svelte/tw.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./HeroSection.translations.json" with { type: "json" };
	import ImageSection from "./ImageSection.svelte";

	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();
	const { CHRISTMAS_HOMEPAGE_ENABLED } = getGlobalSettings();
	const christmasLogoShade = tw("bg-[radial-gradient(ellipse_45%_40%_at_50%_50%,rgb(0_0_0/0.55),transparent)]");
</script>

<ImageSection
	lcp
	class="first:*:pt-24 md:h-[calc(100vh-6rem)] !min-h-170 lg:h-[calc(100vh-7rem)] xl:h-[calc(100vh-8rem)] 2xl:md:h-[calc(100vh-9rem)]"
	sources={CHRISTMAS_HOMEPAGE_ENABLED
		? { default: christmasHeroImage }
		: {
				default: heroImageXs,
				">lg": heroImageLg,
				">sm": heroImageSm,
				">xl": heroImageXl,
				">3xl": heroImage3xl,
			}}
	media={CHRISTMAS_HOMEPAGE_ENABLED ? undefined : "xl:object-[50%_25%] 2xl:object-[50%_35%]"}
	darkOverlay={CHRISTMAS_HOMEPAGE_ENABLED && christmasLogoShade}
>
	{#snippet heading()}
		<Heading
			level={1}
			text={translate("coffee")}
			class="absolute w-[min(84vw,42rem)] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
		>
			<Icon icon={logo} class="text-white size-full" />
		</Heading>
	{/snippet}
	{#snippet actions()}
		{#if CHRISTMAS_HOMEPAGE_ENABLED}
			<Link
				href={getChristmasPath(tenant)}
				size={ButtonSize.Medium}
				variant={ButtonVariant.White}
				onclick={(): void => {
					clarityEvent("hpHeroCtaChristmas");
				}}
			>
				<Formatted text={translate("christmasOffer")} />
			</Link>
		{:else}
			<Link
				href={getCategoryPath(tenant.locale, CategoryType.Coffee)}
				size={ButtonSize.Medium}
				variant={ButtonVariant.White}
				onclick={(): void => {
					clarityEvent("hpHeroCtaShop");
				}}
			>
				<Formatted text={translate("currentOffer")} />
			</Link>
		{/if}
		<BuildYourSubscriptionButton
			variant={ButtonVariant.OutlinedWhite}
			onclick={(): void => {
				clarityEvent("hpHeroCtaSubscription");
			}}
		/>
	{/snippet}
</ImageSection>
